import { render, staticRenderFns } from "./Searchpage.vue?vue&type=template&id=49da9b78&scoped=true&"
import script from "./Searchpage.vue?vue&type=script&lang=js&"
export * from "./Searchpage.vue?vue&type=script&lang=js&"
import style0 from "./Searchpage.vue?vue&type=style&index=0&id=49da9b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da9b78",
  null
  
)

export default component.exports